import {TransactionEditor} from "./CreateQuotation.jsx";
export default function CreateDraft(props){return <TransactionEditor {...props} kind="draft"/>;}
